import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store/store';

interface ProcessListState {
    list: string[][],
  }
  
const initialState:ProcessListState = {
    list:[],
}

export const ProcessListSlice = createSlice({
    name:"processList",
    initialState,
    reducers:{
        UpdateProcessList: (state,action) => {
            state.list = action.payload.processList;
        },
        AddProcess: (state,action) => {
            state.list = [];
        },
        EditProcess: (state,action) => {
            state.list = [];
        },
        RemoveProcess: (state,action) => {
            state.list = [];
        }
    }
})

export const {UpdateProcessList,AddProcess,EditProcess,RemoveProcess} = ProcessListSlice.actions

export const selectProcessList = (state: RootState) => state.processList

export default ProcessListSlice.reducer;